'use client';

import React from 'react';
import ReactPlayer from 'react-player';
import { IoPause } from 'react-icons/io5';


import { VideoBlockProps } from '../../_blocks/VideoBlockGraphQL/types';
import { Gutter } from '../Gutter';
import classes from './VideoBlock.module.scss';
import { VideoPlayerProvider, useVideoPlayer } from '../VideoPlayerContext';
import { PlayButton } from './PlayButton';

export const VideoBlockRaw: React.FC<{
  className?: string;
  videoBlock: VideoBlockProps;
}> = ({
  className,
  videoBlock,
}) => {
  const {
    data: {
      isPlaying,
      playerRef,
    },
  } = useVideoPlayer();

    return (
      <Gutter className={[className, classes.wrapper].filter(Boolean).join(' ')}>
        <div className={classes.videoWrapper}>
          <ReactPlayer
            ref={playerRef}
            src={videoBlock.video}
            style={{ position: 'absolute', top: 0, left: 0 }}
            width="100%"
            height="100%"
            playing={isPlaying}
            controls={true}
            preload="metadata"
          />
        </div>
      </Gutter>
    );
  };

export const VideoBlock: React.FC<{
  className?: string;
  videoBlock: VideoBlockProps;
}> = (props) => (
  <VideoPlayerProvider>
    <VideoBlockRaw {...props} />
  </VideoPlayerProvider>
);

export default VideoBlock;
